// extracted by mini-css-extract-plugin
export default {"scrubber":"styles__scrubber--qi4p0","isActive":"styles__isActive--umQE8","thumb":"styles__thumb--x04Ex","time":"styles__time--eurDu"};